module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-douwe-egberts-intro-card1.2@2x.1a20597d.jpg";